import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import { useState } from "react";
import {
    Button,
    IconButton,
    Menu,
    MenuItem,
    ListItemIcon,
    ListItemText,
    Chip,
    Divider,
    Stack
} from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import VideoLibraryOutlinedIcon from '@mui/icons-material/VideoLibraryOutlined';
import SlowMotionVideoOutlinedIcon from '@mui/icons-material/SlowMotionVideoOutlined';

const VideoTutorials = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");
    const [categoryFilter, setCategoryFilter] = useState("all");
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [selectedItem, setSelectedItem] = useState<any>(null);

    const handleMenuOpen = (event: React.MouseEvent<HTMLElement>, item: any) => {
        setAnchorEl(event.currentTarget);
        setSelectedItem(item);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
        setSelectedItem(null);
    };

    const [videoItems, setVideoItems] = useState([
        {
            id: 1,
            title: "How to Set Up Your Store",
            category: "Vendor Onboarding",
            views: 4500,
            likes: 120,
            duration: "3:47",
            isVisible: true
        },
        {
            id: 2,
            title: "Managing Your Products",
            category: "Vendor Onboarding",
            views: 3200,
            likes: 85,
            duration: "5:12",
            isVisible: true
        },
        {
            id: 3,
            title: "Understanding Payments & Payouts",
            category: "Financials",
            views: 2800,
            likes: 64,
            duration: "6:28",
            isVisible: true
        },
        {
            id: 4,
            title: "Creating Promotions & Coupons",
            category: "Marketing",
            views: 1560,
            likes: 42,
            duration: "7:45",
            isVisible: true
        },
        {
            id: 5,
            title: "Fikra AI Lab: Power User Guide",
            category: "AI Tools",
            views: 5600,
            likes: 310,
            duration: "12:15",
            isVisible: true
        },
        {
            id: 6,
            title: "Advanced Inventory Techniques",
            category: "Vendor Onboarding",
            views: 940,
            likes: 15,
            duration: "5:10",
            isVisible: false
        },
    ]);

    const filteredItems = videoItems.filter(item => {
        const matchesSearch = item.title.toLowerCase().includes(searchTerm.toLowerCase());
        const matchesCategory = categoryFilter === "all" || item.category === categoryFilter;
        return matchesSearch && matchesCategory;
    });

    return (
        <>
            <div className="main_title">
                <h1>Video Tutorials Management</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
                    <button onClick={() => navigate("/admin-support")}> Admin Support </button> -
                    Video Tutorials
                </p>
            </div>

            <div className="stats_boxes gap_m mb_20">
                <div className="cards">
                    <div className="data_top">
                        <h2>48 <p>Total Videos</p></h2>
                        <figure className="blue"><VideoLibraryOutlinedIcon fontSize="large" /></figure>
                    </div>
                </div>
                <div className="cards">
                    <div className="data_top">
                        <h2>12 <p>Categories</p></h2>
                        <figure className="warning"><SlowMotionVideoOutlinedIcon fontSize="large" /></figure>
                    </div>
                </div>
                <div className="cards">
                    <div className="data_top">
                        <h2>1.2M <p>Total Views</p></h2>
                        <figure className="sucess"><VisibilityOutlinedIcon fontSize="large" /></figure>
                    </div>
                </div>
                <div className="cards">
                    <div className="data_top">
                        <h2>85k <p>Total Likes</p></h2>
                        <figure className="danger"><ThumbUpOutlinedIcon fontSize="large" /></figure>
                    </div>
                </div>
            </div>

            <div className="cards">
                <div className="table_header">
                    <div className="left_s">
                        <SearchBar
                            searchTerm={searchTerm}
                            setDebouncedSearchTerm={setSearchTerm}
                            placeholder="Search tutorials..."
                        />
                        <div className="form ml_10">
                            <select value={categoryFilter} onChange={(e) => setCategoryFilter(e.target.value)}>
                                <option value="all">Categories</option>
                                <option value="Vendor Onboarding">Vendor Onboarding</option>
                                <option value="Financials">Financials</option>
                                <option value="Marketing">Marketing</option>
                                <option value="AI Tools">AI Tools</option>
                            </select>
                        </div>
                    </div>
                    <div className="right_s">
                        <Button className="btn btn_primary" onClick={() => navigate("add")}><AddIcon /> Add New Tutorial</Button>
                    </div>
                </div>

                <div className="video-grid mt_20">
                    {filteredItems.map((item, i) => (
                        <div className={`video-card v2 ${!item.isVisible ? 'hidden_item' : ''}`} key={i}>
                            <div className="thumb" >
                                <span className="play-btn"><PlayCircleOutlineIcon sx={{ fontSize: 40 }} /></span>
                                <div className="card_actions_overlay v2">
                                    <IconButton size="small" onClick={(e) => handleMenuOpen(e, item)}>
                                        <MoreVertIcon fontSize="small" />
                                    </IconButton>
                                </div>
                            </div>

                            <div className="video_info_content">
                                <div className="d_flex justify-between align-center mb_10">
                                    <Chip label={item.category} size="small" sx={{ fontSize: '10px', height: '20px' }} />
                                    {!item.isVisible && <Chip label="Hidden" size="small" variant="outlined" color="warning" sx={{ fontSize: '10px', height: '20px' }} />}
                                </div>
                                <h4>{item.title}</h4>
                                <div className="card_footer_meta">
                                    <span className="meta_item"><VisibilityOutlinedIcon sx={{ fontSize: 14 }} /> {item.views.toLocaleString()}</span>
                                    <span className="meta_item"><ThumbUpOutlinedIcon sx={{ fontSize: 14 }} /> {item.likes}</span>
                                    <span className="time">{item.duration}</span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                <MenuItem onClick={handleMenuClose}>
                    <ListItemIcon><EditIcon fontSize="small" /></ListItemIcon>
                    <ListItemText>Edit Tutorial</ListItemText>
                </MenuItem>
                <MenuItem onClick={handleMenuClose}>
                    <ListItemIcon>
                        {selectedItem?.isVisible ? <VisibilityOffIcon fontSize="small" /> : <VisibilityIcon fontSize="small" />}
                    </ListItemIcon>
                    <ListItemText>{selectedItem?.isVisible ? 'Hide Tutorial' : 'Publish Tutorial'}</ListItemText>
                </MenuItem>
                <Divider />
                <MenuItem onClick={handleMenuClose} sx={{ color: '#d32f2f' }}>
                    <ListItemIcon><DeleteOutlineIcon fontSize="small" sx={{ color: '#d32f2f' }} /></ListItemIcon>
                    <ListItemText>Remove</ListItemText>
                </MenuItem>
            </Menu>

        </>
    );
}
export default VideoTutorials;